export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"hid":"theme-color","property":"theme-color","content":"#202020"},{"hid":"author","name":"author","content":"eight&four"},{"hid":"og:site_name","property":"og:site_name","content":"eight&four"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"fb:page_id","property":"fb:page_id","content":"314192535267336"},{"name":"google-site-verification","content":"v9Ke0qJlPZvcjsWggzR6gAOVVq6RXQ2kSVdZONXvukQ"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.googleapis.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://use.typekit.net"},{"rel":"preconnect","href":"https://use.typekit.net","crossorigin":"anonymous"},{"href":"https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Poppins&display=swap","rel":"stylesheet"},{"rel":"stylesheet","href":"https://use.typekit.net/ags7icb.css"}],"style":[],"script":[{"children":"\n                        window.TERMLY_CUSTOM_BLOCKING_MAP = {\n                            \"https://player.vimeo.com\": \"essential\",\n                            \"player.vimeo.com\": \"essential\",\n                        }\n                    "},{"src":"https://app.termly.io/resource-blocker/ea9fa75e-64c0-494f-8e24-ddb198b66a6f?autoBlock=on"},{"children":"\n                    <!-- Google Tag Manager -->\n                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                    })(window,document,'script','dataLayer','GTM-PHCPXKCH');\n                    <!-- End Google Tag Manager -->\n                   "},{"src":"https://www.google.com/recaptcha/api.js?render=6LfFDncpAAAAALaxmHmzZutMIRSGO6KQheHA7lKz"}],"noscript":[],"title":"eight&four | A Performance Driven Social and Content Agency","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true